import React from "react";
import PropTypes from "prop-types";
import { Button, Modal } from "@sainsburys-tech/fable";

class ButtonWithApiCall extends React.Component {
  state = {
    saving: false,
    showError: false
  };

  render() {
    return (
      <React.Fragment>
        {this.state.saving && (
          <LoadingView message={this.props.savingMessage} />
        )}
        {this.props.useInlineError ? (
          this.state.showError && (
            <div className="fable:mb-4">
              <ErrorMessage
                description={
                  this.state.apiError
                    ? ErrorRegistry.getErrorMessage(this.state.apiError)
                    : ""
                }
              />
            </div>
          )
        ) : (
          <Modal
            size="sm"
            onClose={() => this.setState({ showError: false })}
            isOpen={this.state.showError}
            header={{ title: "Error", as: "h3" }}
          >
            <p>{this.state.error}</p>
          </Modal>
        )}
        {this.props.managersOverrideButton ? (
          <Button variant="outlined" onClick={() => this.handleClick()}>
            Turn managers override off
          </Button>
        ) : (
          <Button
            onClick={() => this.handleClick()}
            isFullWidth
            colourScheme="dark"
            disabled={this.props.disabled}
          >
            {this.props.label}
          </Button>
        )}
      </React.Fragment>
    );
  }

  handleClick() {
    if (this.props.onValidate) if (!this.props.onValidate()) return;

    this.setState({ saving: true, error: undefined, showError: false });
    this.props.onClick().then(
      result => {
        this.setState({ saving: false }, () => {
          if (this.props.onComplete) {
            this.props.onComplete(result);
          }
        });
      },
      r => {
        let errMsg = "Error";
        if (r.status === 409) {
          errMsg =
            "This data may have changed since the page was loaded. Please refresh the page and try again";
        }
        if (r.status === 400) {
          if (r.body) {
            errMsg = r.body.description;
          }
        }

        if (this.props.onFailed) this.props.onFailed();
        this.setState({
          saving: false,
          error: errMsg,
          showError: true,
          apiError: r
        });
      }
    );
  }
}

ButtonWithApiCall.propTypes = {
  onClick: PropTypes.func.isRequired,
  onComplete: PropTypes.func,
  onFailed: PropTypes.func,
  label: PropTypes.string,
  savingMessage: PropTypes.string,
  fullWidth: PropTypes.bool,
  disabled: PropTypes.bool,
  onValidate: PropTypes.func,
  useInlineError: PropTypes.bool,
  managersOverrideButton: PropTypes.bool
};

ButtonWithApiCall.defaultProps = {
  label: "Save",
  savingMessage: "Saving",
  fullWidth: false,
  disabled: false
};

export default ButtonWithApiCall;
